import { z } from 'my-zod'
import { additionalCustomerOrderQuestionModel } from './additional-customer-order-question-model'

export const additionalCustomerOrderQuestionUpdate = additionalCustomerOrderQuestionModel
  .pick({
    outfitterId: true,
    type: true,
    prompt: true,
    description: true,
    productIds: true,
    orderOfAppearance: true
  })
  .extend({
    prompt: z.string().max(256).min(1, { message: 'Required' })
  })

export type additionalCustomerOrderQuestionUpdate = z.infer<typeof additionalCustomerOrderQuestionUpdate>
